import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { BaseService } from '../../../shared/services/base.service';

@Injectable()
export class LocalizationService extends BaseService {
	constructor(private readonly http: HttpClient) {
		super();
	}

	verifyRegionSupport(latitude: number, longitude: number) {
		return this.http.get<any>(`${environment.apiUrl}dealerships/verifications/area-supports/latitude/${latitude}/longitude/${longitude}`).pipe(take(1));
	}
}
